import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 4l6 16l6 -16","key":"svg-0"}]]

const IconLetterV = createReactComponent('outline', 'letter-v', 'LetterV', __iconNode);

export default IconLetterV;